import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import homeDash from './home';

const Dashboards = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/home`} />
            <Route path={`${match.url}/home`} component={homeDash} />
            <Redirect to="/error" />

        </Switch>
    </div>
);
export default Dashboards;